import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginBBMMService } from './loginbbmm.service';
import { AuthService } from '../services/auth.service';
import { Title } from '@angular/platform-browser';
import { Config } from '../../config/config';
import { Subscription } from 'rxjs';
import { SignalRService } from 'app/services/signalR.service';

var Base64 = require('js-base64').Base64;

@Component({
    selector: 'vnpt-loginbbmm',
    templateUrl: './loginbbmm.component.html',
    providers: [LoginBBMMService]

})
export class LoginBBMMComponent implements OnInit {
    busy: Subscription;
    username: any;
    password: any;
    lt: any;
    jsession: any;
    try_count: number = 0;
    loginErrorStatus: string = "";
    isSubmit = false;
    isShow = false;
    imgUrl = Config.apiUrl + 'APIPAHT/Get_File?f=';
    sso_used: boolean = false;

    saveInfo: boolean = false;

    get systemConfig(): any {
        return this.authService.systemConfig;
    }

    constructor(private loginService: LoginBBMMService,
        public authService: AuthService,
        private signalRService: SignalRService,
        private router: Router,
        private titleService: Title) {
        titleService.setTitle("Đăng nhập hệ thống");
    }

    ngOnInit() {
        if (this.authService.isLoggedIn) {
            // this.router.navigate(['xl-xu-ly-su-co/xu-ly-su-co-new']);
            this.router.navigate(['phan-anh/browse']);
        } else {
            this.authService.isLoggedIn = false;
            this.loginErrorStatus = "";

            let saveLogin = window.name;
            if (saveLogin) {
                const info = JSON.parse(Base64.decode(saveLogin));
                this.username = info.username;
                this.password = info.password;

                this.saveInfo = true;
            } else {
                this.saveInfo = false;
            }
        }
    }

    login() {
        this.isSubmit = true;
        this.isShow = false;
        // this.loginErrorStatus = "Đang kiểm tra dữ liệu vui lòng đợi...";
        if (this.username.trim() == '' || this.password.trim() == '') {
            this.loginErrorStatus = "Chưa nhập đầy đủ thông tin";
            this.isShow = true;
            return;
        }
        this.authService.isLoading = true;
        this.busy = this.loginService.login(this.username, this.password)
            .subscribe(
                (data) => {
                    this.doLogin(data);
                    this.authService.isLoading = false;
                },
                (e) => {
                    this.loginErrorStatus = "Lỗi: Tên đăng nhập/mật khẩu không đúng";
                    this.isSubmit = false;
                    this.isShow = true;
                    this.authService.isLoading = false;
                })

    }

    doLogin(data) {
        if (this.saveInfo) {
            const info = {
                username: this.username,
                password: this.password
            };
            window.name = Base64.encode(JSON.stringify(info));
        } else {
            window.name = '';
        }
        localStorage.setItem("scnntttoken", data.access_token);
        localStorage.setItem("expires", data[".expires"]);
        this.authService.getUserRolesInfo(data.access_token, "quyen").subscribe(
            (info: any) => {
                this.authService.dsRoutes = info.routesInfo;
                this.authService.user = info.userInfo;
                var jsonString = JSON.stringify(info);
                var encodedString = Base64.encode(jsonString);
                localStorage.setItem("userInfo", encodedString);
                // this.authService.loadSystemConfig();
                this.signalRService.connectSignalR();
                if (this.authService.redirectUrl == null || this.authService.redirectUrl == undefined)
                    // this.router.navigate(['./xl-xu-ly-su-co/xu-ly-su-co-new']);
                    this.router.navigate(['./phan-anh/browse']);
                else
                    this.router.navigate([this.authService.redirectUrl]);
                this.authService.isLoggedIn = true;

            },
            (e) => {
                this.loginErrorStatus = "Lỗi: Hệ thống có lỗi, xin vui lòng quay lại sau";
                console.log(e);
            });
    }

    clickLoginSSO() {
        window.location.href = Config.sso;
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/login-bbmm/loginbbmm.component.ts